<script setup lang="ts">
import type { UniquePost } from "@/server/api/types";
import { ROUTE_BLOG_CATEGORY } from "~/constants/routes";

const { replaceParams } = useRouteParams();
const props = defineProps<{
  relatedPosts: UniquePost[];
}>();

const randomPosts = computed(() => props.relatedPosts.slice(0, 3));
</script>
<template>
  <div class="tw-max-w-[1012px] tw-mx-auto">
    <article
      v-for="post in randomPosts"
      :key="post.id"
      class="sm:tw-flex tw-mb-[30px] tw-text-center sm:tw-text-left tw-font-bookmania tw-text-[14px] tw-leading-[1.36]"
    >
      <nuxt-link
        :to="post.link"
        class="tw-bg-cover tw-bg-center tw-bg-no-repeat sm:tw-w-1/2 tw-min-h-[200px] tw-block"
        :style="{
          backgroundImage: `url(${post.featuredImage})`,
        }"
      ></nuxt-link>
      <div class="sm:tw-w-1/2 tw-bg-white tw-pl-7 tw-pr-[35px] tw-pt-7 tw-pb-[33px]">
        <span
          class="tw-block tw-font-bold tw-font-agendaCond tw-text-[14px] tw-tracking-[0.09em] tw-uppercase tw-mb-2"
        >
          <span class="tw-text-nl-green-200">Categories:</span>
          <template
            v-for="(category, index) in post.categories"
            :key="category?.name"
          >
            <nuxt-link
              :to="{path: replaceParams(ROUTE_BLOG_CATEGORY, {slug: category?.slug})}"
              rel="category tag"
            >
              {{ category?.name }}
            </nuxt-link>
            <span v-if="index !== post.categories.length - 1">, </span>
          </template>
        </span>
        <h2 class="tw-font-bold tw-text-[24px] tw-leading-[1.25] tw-mb-[30px] sm:tw-mb-[13px]">
          <nuxt-link :to="post.link">{{ post.title }}</nuxt-link>
        </h2>
        <div class="tw-hidden sm:tw-block tw-mb-[18px]" v-html="post.excerpt"></div>
        <nuxt-link
          :to="post.link"
          class="tw-font-bold tw-font-agendaCond tw-text-[14px] tw-uppercase tw-tracking-[0.04em] tw-text-nl-green-200 hover:tw-text-nl-green-100 tw-transition tw-duration-300 tw-ease-linear tw-inline-block tw-align-top"
        >Read more</nuxt-link>
      </div>
    </article>
  </div>
</template>
